import { Navigate } from 'react-router-dom';

const DashboardsView = async () =>
    import('../../pages/dashboards/ViewerPage').then((module) => ({
        Component: module.ViewerPage,
    }));

const getDashboardRoutes = (user) => {
    if (user?.carrierId) return [];

    if (user?.features?.disableAnalytics) {
        return [
            { path: '/analytics-new/', element: <Navigate to='/exit-orders/' /> },
            { path: '/analytics/', element: <Navigate to='/exit-orders/' /> },
        ];
    }

    return [
        {
            path: '/analytics-new/', // Old temp URL
            element: <Navigate to='/analytics/' />,
        },
        {
            path: '/analytics/',
            lazy: DashboardsView,
        },
    ];
};

export { getDashboardRoutes };
